export default {
  title_add_comment_to_entity: "Add comment to {entity}",
  label_add_comment_and_photos: "Add your comment (and photos) here",
  label_comment: "Comment",
}
